import { useParams } from 'react-router-dom';
import { Text } from '../../components/units/Text';
import { useEffect, useState } from 'react';
import { Divider } from '../../components/units/Divider';
import React from 'react';
import { DetailText } from '../../components/units/Text';
import { 
    AccumulatorDetailWidget, 
    SohWidget, 
    AccumulatorProfileWidget, 
    EfficiencyWidget, 
    CyclesWidget, 
    StatisticsCharts, 
    WidgetTitle, 
    IconLocation 
} from '../../components/Accumulator/Widgets';
import { fetchAcbDetails, fetchChartData, AccumulatorDetails } from '../../components/Rest/FetchACB';
import './ACBView.css'
import { BoxWrapper, ConditionalWrapper } from '../../components/Wrappers/Wrappers';
import { useSignedInContext } from '../../context/AuthContextProvider';
import { ChartDataResponse } from '../../components/Rest/FetchACB';
import { ServiceInfo } from '../../components/Accumulator/ServiceInfo';
// import { fetchCommissionData, CommisionProps } from '../../components/Rest/Commission';
import { fetchCommissionData } from '../../components/Rest/accumulator/components/fetchCommissionData';
import { hasPermission } from '../../roles/roles';
import { JournalHandler } from '../../components/Journal/Journal';
import { fetchJournal } from '../../components/Rest/Journal';
import { InfoBlock } from '../../interfaces/AccumulatorView/types';
import { RestApiState } from '../../interfaces/Rest/types';
import AcbOsSection from '../../features/AcbOsSection/AcbOsSection';
import { Loader } from '../../components/units/Loader';
import { Map } from '../../components/Map/Map';
import { DateRangePicker, dateRangeValues } from '../../components/Pickers/v2/datePicker';
import { selectedDateRangeRest } from '../../components/Pickers/dataRange';
import { AcbViewProps } from '../../interfaces/AccumulatorView/types';
import { JournalResponse } from '../../interfaces/Journal/types';
import { downloadJournal } from '../../components/Rest/Journal';
import { 
    DateRangeEnum,
    DateRangeProps,
    EnumToRangeProps,
    DateRangeComponentProps,
    RangeHandlerParams
 } from '../../interfaces/DatePicker/types';


// TODO add cache
// Refactor everything!!!

const MapWrapper = React.memo(
    () => {
        return <div id="map-container" style={{ width: '100%', height: '100%' }}></div>;
    },
    () => true,
);


const LocationWidget = (accumulator: AccumulatorDetails | undefined) => {
    return (
        <BoxWrapper className="flex flex-column no-padding show-up-quick" bg="bg-primary" p="p0" r="r15">
            <div className="default-padding" style={{paddingBottom: 0}}>
                <WidgetTitle label="Местоположение батареи" icon={IconLocation()} />
                <div className="default-padding">
                    <Text size="sm" color="orange">Местоположение определено по GSM (точность определения  - до 1000 метров)</Text>
                </div>
            </div>
            {
                accumulator ? (
                    <div className="chart four-cols">
                        <Map coords={accumulator.coordinates}/>
                    </div>
                ) : (
                    <div>
                        <Text>Нет данных</Text>
                    </div>
                )
            }
        </BoxWrapper>
    )
}

interface SectionSelectorProps {
    label: string;
    currentSection: InfoBlock;
    nextSection: InfoBlock;
    setSection: (value: InfoBlock) => void;
}

const SectionSelector = ({ label, currentSection, nextSection, setSection }:SectionSelectorProps) => {
    return (
        <Text 
            size="xl" 
            color={ currentSection === nextSection ? 'primary' : 'secondary' } 
            className={`bold fit pointer ${currentSection === nextSection ? 'selected' : ''}`}
            onClick={(e)=>setSection(nextSection)}
        >{ label }</Text>
    )
}

const ACBView = () => {
    // Refactor all of those useStates
    const { user } = useSignedInContext()
    const { serial_number } = useParams()
    if (!serial_number) {
        throw new Error("Serial number must be provided")
    }

    // const [infoBlock, setInfoBlock] = useState<InfoBlock>(InfoBlock.StatisticsInfo)
    const [accumulator, setAccumulator] = useState<AccumulatorDetails | undefined>(undefined)
    const [viewProps, setViewProps] = useState<AcbViewProps>({
        section: InfoBlock.StatisticsInfo,
        statisticsSectionView : {
            calendar: {
                isOpen: false,
                dateRange: DateRangeEnum.Month
            },
            data: null,
            params: dateRangeValues({dateRange:DateRangeEnum.Month}),
        },
        commissionSectionView: {
            data: undefined
        },
        journalSectionView: {
            calendar: {
                isOpen: false,
                dateRange: DateRangeEnum.Month
            },
            data: undefined,
            pagination: {
                isOpen: false
            },
            params: {
                isMessage: false,
                isWarning: true,
                isError: true,
                isBmsEvent: false,
                limit: 10,
                currentPage: 1,
                offset: 0,
                period: selectedDateRangeRest(DateRangeEnum.Month)
                // ...dateRangeValues({dateRange:DateRangeEnum.Month})
            },
            download: {
                requestState: RestApiState.Idle,
                btnDisabled: false,
                timeout: null
            }
        }
    })

    if (serial_number === undefined) {
        throw "Serial number must be provided as parameter"
    }

    const setSection = (value: InfoBlock):void => {
        setViewProps(prev=>({
            ...prev, section: value
        }))
    }

    useEffect(() => {
        const fetchList = async () => {
            await fetchAcbDetails(user.role_slug, serial_number, setAccumulator)
        }
        fetchList()
    }, [serial_number])

    useEffect(() => {
        const fetchSectionData = async () => {
            if (viewProps.section === InfoBlock.ServiceInfo) {
                const response = await fetchCommissionData(serial_number, user.role_slug)
                if (response) {
                    setViewProps( prev => ({
                        ...prev, commissionSectionView : {
                            ...prev.commissionSectionView, data: response
                        }
                    }))
                } 

            } else if (viewProps.section === InfoBlock.Journal) {
                const response = await fetchJournal(serial_number, user.role_slug, viewProps.journalSectionView.params)
                if (response) {
                    setViewProps( prev => ({
                        ...prev, journalSectionView : {
                            ...prev.journalSectionView, data: response
                        }
                    }))
                }
            } else if (viewProps.section === InfoBlock.StatisticsInfo) {
                let trunc = 'hour'

                if (viewProps.statisticsSectionView.calendar.dateRange === DateRangeEnum.Today) {
                    trunc = 'hour'
                } else if (viewProps.statisticsSectionView.calendar.dateRange === DateRangeEnum.Week) {
                    trunc = 'two_hours'
                } else {
                    trunc = 'four_hours'
                }
                const response = await fetchChartData(user.role_slug, serial_number, viewProps.statisticsSectionView.params, trunc)
                setViewProps( prev => ({
                    ...prev, statisticsSectionView : {
                        ...prev.statisticsSectionView, data: response.data
                    }
                }))
            }
        }
        fetchSectionData()
    }, [
        serial_number, 
        viewProps.section, 
        viewProps.statisticsSectionView.params,
        viewProps.journalSectionView.params
    ]) //Add journal params here


    return (
        <div className='content-wrapper acb-dashboard-wrapper show-up'>
            <DetailText href='/react/'>
                Назад
            </DetailText>
            <br />
            <br />
            <div className="acb-header">
                {accumulator !== undefined ? (
                    <>
                    { AccumulatorProfileWidget(accumulator) } 
                    { AccumulatorDetailWidget(accumulator) }
                    { SohWidget(accumulator, setSection) }
                    { EfficiencyWidget(accumulator)}
                    { CyclesWidget(accumulator) }
                    </>

                ): (
                    <>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                    </>
                )}
            </div>
            <br />
            <div className='full-width overflow-x-auto text-no-wrap no-scroll-bar'>
                <div className='h-wrapper'>
                    <div className="selectors">
                        <SectionSelector 
                            label='Статистика' 
                            currentSection={viewProps.section}
                            nextSection={InfoBlock.StatisticsInfo} 
                            setSection={ setSection } 
                        />
                        <ConditionalWrapper condition={hasPermission({role:user.role, resource:'Commission', action:'view'})}>
                            <SectionSelector 
                                label='Служебная информация' 
                                currentSection={viewProps.section}
                                nextSection={InfoBlock.ServiceInfo} 
                                setSection={ setSection } 
                            />
                        </ConditionalWrapper>
                        <ConditionalWrapper condition={hasPermission({role:user.role, resource:'OS', action:'view'})}>
                            <SectionSelector 
                                label='Обновление' 
                                currentSection={viewProps.section}
                                nextSection={InfoBlock.OS} 
                                setSection={ setSection } 
                            />
                        </ConditionalWrapper>
                        <SectionSelector 
                            label='Журнал' 
                            currentSection={viewProps.section}
                            nextSection={InfoBlock.Journal} 
                            setSection={ setSection } 
                        />
                        <SectionSelector 
                            label='Локация' 
                            currentSection={viewProps.section}
                            nextSection={InfoBlock.LocationInfo} 
                            setSection={ setSection } 
                        />
                    </div>
                </div>
            </div>
            <Divider />
            { 
                viewProps.section === InfoBlock.StatisticsInfo && 
                    StatisticsCharts(viewProps.statisticsSectionView, setViewProps)
            }
            { 
                viewProps.section === InfoBlock.LocationInfo && 
                    LocationWidget(accumulator)
            }
            { 
                (viewProps.section === InfoBlock.ServiceInfo && hasPermission({role:user.role, resource:'Commission', action:'view'}))  && 
                    ServiceInfo(serial_number, viewProps.commissionSectionView?.data)
            }
            { 
                (viewProps.section === InfoBlock.Journal) && (
                    <JournalHandler
                        serial_number={serial_number}
                        props={viewProps.journalSectionView}
                        setViewProps={setViewProps}
                        action={
                            (e: any) => {
                                e.preventDefault();
                                downloadJournal(serial_number, user.role_slug, (value: RestApiState) => {
                                    setViewProps(prev => ({
                                        ...prev,
                                        journalSectionView: {
                                            ...prev.journalSectionView,
                                            download: {
                                                ...prev.journalSectionView.download,
                                                requestState: value
                                            }
                                        }
                                    }))
                                }, viewProps.journalSectionView.params)
                            }
                        }
                    />
                )
                
            }
           <ConditionalWrapper condition={viewProps.section===InfoBlock.OS && hasPermission({role:user.role, resource:'OS', action:'view'})}>
                <AcbOsSection data={accumulator} />
            </ConditionalWrapper> 
        </div>
    )    
}

export default ACBView